import './index.less'

export default class OldInviteNewSteps {
  constructor() {
    this.linkButtons = document.querySelectorAll('[data-old-invite-new-link-button]')

    if (this.linkButtons.length > 0) {
      this.init()
    }

    // 出场动画
    const stepsDOMList = document.querySelectorAll('[data-old-invite-new-steps]')
    stepsDOMList.forEach(dom => {
      this.observe(dom)
    })
  }
  init() {
    this.linkButtons.forEach(item => {
      item.onclick = e => {
        const { linkUrl, moduleTitle, index, } = e.target.dataset
        if (linkUrl) {
          // 数据埋码
          this.GAEvent({
            module: moduleTitle,
            position: `Step ${index * 1 + 1}`,
            button_name: e.target.innerText,
            link: linkUrl,
            status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
          })

          // 因为苹果的安全机制拦截了，所以不能打开新的标签页
          window.open(linkUrl, '_blank')
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });

          // 数据埋码
          this.GAEvent({
            module: moduleTitle,
            position: `Step ${index * 1 + 1}`,
            button_name: e.target.innerText,
            status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
          })
        }
      }
    })
  }

  // 数据埋码
  GAEvent(params) {
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event":"ga4Event",
      "event_name":"refer_new_user_clicks",
      "event_parameters":{
        "current_page": window.location.href, // current page url
        ...params
      }
    });
  }

  // 出场动画
  observe(sectionDOM) {
    const Observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active')
        }
      })
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.2,
    })

    const targetDOMs = sectionDOM?.querySelectorAll('[data-animation-dom]')
    if (targetDOMs.length > 0) {
      targetDOMs.forEach(it => Observer.observe(it))
    }
  }
}

new OldInviteNewSteps();
